import { NgIf } from '@angular/common';
import { Component } from '@angular/core';
import { FormControl, ValidatorFn } from '@angular/forms';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import type { ICellRendererParams } from 'ag-grid-community';
import { CountyAttributes } from '~app/models';
import { FieldErrorListComponent } from '../forms/field/field-error-list/field-error-list.component';
import { param } from 'jquery';

export interface IValidatableRendererParams {
  validators: ValidatorFn[];
}

type CellRendererParams = {
  county?: CountyAttributes;
  regionList?: any;
} & IValidatableRendererParams &
  ICellRendererParams;

@Component({
  selector: 'ciao-cell-renderer',
  imports: [NgIf, FieldErrorListComponent],
  templateUrl: './cell-renderer.component.html',
  styleUrl: './cell-renderer.component.less',
})
export class CellRendererComponent {
  params: CellRendererParams;
  value;
  comboBoxLabel: string = null;
  formControlInput?: FormControl;

  agInit(params: CellRendererParams): void {
    this.params = params;
    this.setValue(params);
  }

  private setValue(params: CellRendererParams) {
    this.value = params?.value;
    // do some special checking for county
    if (this.params?.colDef?.field === 'county' && params?.data?.county) {
      this.value = `${params?.data?.county?.state.stateName} | ${params?.data?.county?.countyName} | ${params?.data?.county?.id}`;
    }

    if (this.params?.colDef?.field === 'regionId' && params?.data?.regionId) {
      this.value =
        this.params?.regionList.find((option) => option.value === params.value)
          ?.label || params.value;
    }

    if (this.formControlInput) {
      this.formControlInput.setValue(this.value);
    } else {
      this.formControlInput = new FormControl(this.value, params.validators);
    }
  }

  refresh(params: CellRendererParams): boolean {
    this.params = params;
    this.setValue(params);
    return true;
  }
}
